/**
 * @module Comparison Grid
 * @description
 */
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import styles from "./index.module.css";

const defaultRows = [
  {
    title: "Connect it all",
    copy: (
      <>
        An Amazon eero Pro 6 router is automatically included with your order at
        no additional monthly cost.
        <span data-legal="eero" />
      </>
    ),
    first: true,
    second: false,
  },
  {
    title: "Experience fiber-fast",
    copy: "Access our 100% fiber-optic network",
    first: true,
    second: false,
  },
  {
    title: "Go 10x faster",
    copy: (
      <>
        Experience upload speeds 10x faster than cable
        <span key="span-1" data-legal="Gig-25x-faster-than-cable" />
      </>
    ),
    first: true,
    second: false,
  },
  {
    title: "Unlock unlimited access",
    copy: (
      <>
        Stream, work and game with no data caps or overage charges
        <Tippy
          key="tooltip-1"
          content={
            <p key="paragraph-1" className="tooltip-content--legal">
              Some providers have data caps or excess use charges. Check your
              provider's terms to see if this applies to you.
            </p>
          }
          placement="bottom"
          arrow={true}
          trigger="mouseenter focus click"
          theme="light"
          className="tooltip-icon"
        >
          <button className="tooltip-btn" role="button">
            <span className="icon icon-info-outline" />
            <span className="screen-reader-text">Tooltip Icon</span>
          </button>
        </Tippy>
      </>
    ),
    first: true,
    second: false,
  },
  {
    title: "Game with less lag",
    copy: (
      <>
        Fiber has 2.9x less latency than cable
        <Tippy
          key="tooltip-1"
          content={
            <p key="paragraph-1" className="tooltip-content--legal">
              Source: FCC Thirteenth MBA, Median Idle Latency (1900-2300 M-F)
              [19.09 Cable/6.66 FTR Fiber=2.9]
            </p>
          }
          placement="bottom"
          arrow={true}
          trigger="mouseenter focus click"
          theme="light"
          className="tooltip-icon"
        >
          <button className="tooltip-btn" role="button">
            <span className="icon icon-info-outline" />
            <span className="screen-reader-text">Tooltip Icon</span>
          </button>
        </Tippy>
      </>
    ),
    first: true,
    second: false,
  },
  {
    title: "Save with Auto Pay",
    copy: "Save $10 on your monthly bill when you establish and maintain Auto Pay",
    first: true,
    second: true,
  },
];

/**
 * @function Component
 * @description
 */
const Component = ({ ...props }) => {
  const {
    headline = "How we stack up",
    subhead,
    header1 = "Fiber 1 Gig",
    header2 = "Vs. Cable",
    rows = defaultRows,
  } = props;

  /**
   * @function expandRow
   * @description
   */
  const expandRow = (e) => {
    const copy = e.target.parentNode.parentNode.parentNode;
    copy.classList.toggle("is-active");
  };

  return (
    <section className={`component ${styles.component}`}>
      <div className={`l-container ${styles.lContainer}`}>
        <h2 className={`h2 ${styles.component__headline}`}>{headline}</h2>
        {subhead && <p>{subhead}</p>}
        <div className={styles.component__productHeaders}>
          <h3 className="h6 u-color-red">{header1}</h3>
          <h3 className="h6">{header2}</h3>
        </div>
      </div>

      {rows.map((row, index) => (
        <div
          className={index % 2 === 0 ? "u-theme-white" : "u-theme-light"}
          key={index}
        >
          <div
            className={`l-container ${styles.lContainer} ${styles.component__row}`}
          >
            <div className={styles.component__rowHeader}>
              <button
                type="button"
                className={`show-for-small-only ${styles.component__rowButton}`}
                onClick={expandRow}
              >
                <span
                  className={`icon icon-chevron-down ${styles.component__iconChevron} `}
                />
              </button>

              <div className={styles.component__rowTitleWrapper}>
                <h4 className={`h6 ${styles.component__rowTitle}`}>
                  {row.title}
                </h4>

                {/* DESKTOP COPY */}
                <p className={`show-for-medium ${styles.component__rowCopy}`}>
                  {row.copy}
                </p>
              </div>

              <span
                className={`icon icon-${row.first ? "check-short" : "minus2"} ${styles.component__iconLeft} `}
              />
              <span
                className={`icon icon-${row.second ? "check-short" : `minus2 ${styles.component__iconMinus}`} ${styles.component__iconRight} `}
              />
            </div>

            {/* MOBILE COPY */}
            <p
              className={`show-for-small-only ${styles.component__rowCopyMobile}`}
            >
              {row.copy}
            </p>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Component;
